export const BUYERS = {
    FETCH_BUYERS: {
        MAIN: 'FETCH_BUYERS',
        SUCCESS: 'FETCH_BUYERS_SUCCESS',
        FAILURE: 'FETCH_BUYERS_FAILURE'
    },
};
